import { call, put, takeEvery } from 'redux-saga/effects';
import API from '../../api';
import Mixpanel from '../../../helpers/mixpanel';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { QuestionnairesActionTypes } from '../actions/types';
import { ModalsActionCreators, QuestionnairesActionCreators } from '../actions/creators';
import { toast } from '../../utilities';

function* fetchQuestionnaireByCustomerId({ payload }) {
  try {
    const response = yield call(API.Questionnaires.getDataForUserQuestionnaire, payload.userId);
    yield put(QuestionnairesActionCreators.fetchQuestionnaireByCustomerId[AsyncActionStatus.FULFILLED](
      response.data.questionnaire,
      [response.data.editor || {}, response.data.customer || {}],
    ));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(QuestionnairesActionCreators.fetchQuestionnaireByCustomerId[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

function* updateQuestionnaireByCustomer({ payload }) {
  try {
    const response = yield call(
      API.Questionnaires.updateQuestionnaireByCustomer,
      payload.questionnaireId,
      payload.customerId,
      payload.questionnaireSections,
      payload.shouldSubmit,
    );

    if (payload.customerIsStartingQuestionnaire) Mixpanel.track('Questionnaire begun');
    if (payload.shouldSubmit) Mixpanel.track('Questionnaire submitted');

    yield put(QuestionnairesActionCreators.updateQuestionnaireByCustomer[AsyncActionStatus.FULFILLED](
      response.data,
    ));

    if (payload.shouldSubmit) {
      yield put(ModalsActionCreators.openQuestionnaireSentModal());
    } else {
      yield call(toast.success, t('toastMessages.success.questionnaireAnswersUpdated', { ns: i18next.Namespace.COMMON }));
    }
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(QuestionnairesActionCreators.updateQuestionnaireByCustomer[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

function* getQuestionnaireByProjectId({ payload }) {
  try {
    const response = yield call(API.Questionnaires.getQuestionnaireByProjectId, payload.projectId);
    yield put(QuestionnairesActionCreators.getQuestionnaireByProjectId[AsyncActionStatus.FULFILLED](response.data));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(QuestionnairesActionCreators.getQuestionnaireByProjectId[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

function* createQuestionnaire({ payload }) {
  try {
    const response = yield call(API.Questionnaires.createQuestionnaire, payload.projectId, payload.questionnaire);
    Mixpanel.track('Questionnaire sent');
    yield put(QuestionnairesActionCreators.createQuestionnaire[AsyncActionStatus.FULFILLED](response.data));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(QuestionnairesActionCreators.createQuestionnaire[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

export default [
  takeEvery(
    QuestionnairesActionTypes.fetchQuestionnaireByCustomerId[AsyncActionStatus.PENDING],
    fetchQuestionnaireByCustomerId,
  ),
  takeEvery(
    QuestionnairesActionTypes.updateQuestionnaireByCustomer[AsyncActionStatus.PENDING],
    updateQuestionnaireByCustomer,
  ),
  takeEvery(
    QuestionnairesActionTypes.getQuestionnaireByProjectId[AsyncActionStatus.PENDING],
    getQuestionnaireByProjectId,
  ),
  takeEvery(
    QuestionnairesActionTypes.createQuestionnaire[AsyncActionStatus.PENDING],
    createQuestionnaire,
  ),
];
